module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items-list"
  }, [_c('ul', {
    staticClass: "items"
  }, [(!_vm.isEditPeriod) ? _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Periode")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_vm._v("\n          " + _vm._s(_vm.dateRangeFormatted) + "\n          "), _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": "Redigér periode"
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isEditPeriod = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEditPeriod) ? [_c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Startdato")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.startDate
    },
    on: {
      "changed": _vm.setStartDate
    }
  })], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Slutdato")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.endDate
    },
    on: {
      "changed": _vm.setEndDate
    }
  })], 1)])])] : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Stillingsprosenten")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentPercentage.hours),
      expression: "employmentPercentage.hours"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.employmentPercentage.hours)
    },
    on: {
      "change": function($event) {
        return _vm.employmentPercentageChanged($event.target.value)
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.employmentPercentage, "hours", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "items__item",
    class: {
      'items__item--fixed': _vm.workingHours.isFixed
    }
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.workingHours.title))]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workingHours.hours),
      expression: "workingHours.hours"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.workingHours.hours)
    },
    on: {
      "change": function($event) {
        return _vm.onEditWorkingHours($event.target.value)
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workingHours, "hours", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "items__item",
    class: {
      'items__item--fixed': _vm.planleggingsdager.isFixed
    }
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.planleggingsdager.title))]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planleggingsdager.hours),
      expression: "planleggingsdager.hours"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.planleggingsdager.hours)
    },
    on: {
      "change": function($event) {
        return _vm.onEditPlanleggingsdager($event.target.value)
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.planleggingsdager, "hours", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item__total"
  }, [_c('p', [_vm._v("Sum arbeidstid i 38 uker")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workingHoursWithoutPlanleggingsdager) + " timer")])]), _vm._v(" "), (true) ? _c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v("Reduksjon til undervisning")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.subtractedItems), function(subtractItem, idx) {
    return _c('li', {
      key: subtractItem.id,
      staticClass: "subtract-item items__item"
    }, [(subtractItem.id === 'reduction_employee_percentage') ? [_c('p', {
      staticStyle: {
        "margin-left": "19px"
      }
    }, [_vm._v("\n          Stillingsprosenten reduksjon")]), _c('p', [_vm._v(_vm._s(subtractItem.hours) + "%")])] : [_c('div', {
      staticClass: "subtract-item__title"
    }, [_c('div', {
      staticClass: "d-input-group__input__close icon__bg-circle icon__bg-circle--danger",
      on: {
        "click": function($event) {
          return _vm.deleteItem(subtractItem)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })]), _vm._v("\n            " + _vm._s(subtractItem.title) + "\n          ")]), _vm._v(" "), (subtractItem.isOwn) ? _c('div', {
      staticClass: "input-group__input"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(subtractItem.unit ? subtractItem.unit : 'timer'))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (subtractItem.hours),
        expression: "subtractItem.hours"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (subtractItem.hours)
      },
      on: {
        "focus": function($event) {
          return $event.target.select()
        },
        "change": function($event) {
          return _vm.setSubtractedItemValue(subtractItem, $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(subtractItem, "hours", $event.target.value)
        }
      }
    })]) : _c('p', [_vm._v(_vm._s(subtractItem.hours) + "%")])]], 2)
  }), 0)], 2), _vm._v(" "), _c('ul', {
    staticClass: "items",
    attrs: {
      "id": "items__list"
    }
  }, [(_vm.isAddNew) ? _c('li', {
    staticClass: "items__item items__item__add__new"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItemTitle),
      expression: "newItemTitle"
    }],
    ref: "add_new_input",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newItemTitle)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addOwn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItemTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "items__item__add__new__buttons"
  }, [_c('button', {
    staticClass: "bttn",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary",
    on: {
      "click": _vm.addOwn
    }
  }, [_vm._v("Gem")])])]) : _vm._e()]), _vm._v(" "), _c('DDropdown', {
    staticClass: "add-more__dropdown",
    attrs: {
      "isShowDots": false
    }
  }, [(!_vm.isAddNew) ? _c('p', {
    staticClass: "items__item__add",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("+ Legg til reduksjon")]) : _vm._e(), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('label', {
    staticClass: "d-label d-label__headline"
  }, [_vm._v("Livsfasetiltak")]), _vm._v(" "), _vm._l((_vm.possibleStandardItems), function(possibleItem, idx) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.addFromStandard(possibleItem)
        }
      }
    }, [_vm._v(_vm._s(possibleItem.title) + "\n      ")])
  }), _vm._v(" "), _c('li', {
    staticClass: "items__item__add",
    staticStyle: {
      "border-top": "1px solid #ddd",
      "margin-top": "0.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.setIsAddNew(true)
      }
    }
  }, [_vm._v("+\n        Lag din egen\n      ")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31c11c66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arbeidsplan/ArbeidsplanAssignHoursNormList.vue
// module id = 1842
// module chunks = 1